import React from 'react';

import {Anchor, Banner, Text} from '@albert-io/atomic';

import {TO_DO_PROXIMITY} from './getFilters';

interface Props {
  onSelectFilter: (filter: 'closed' | 'open') => void;
}

/** Follows the To Do list to say what To Do leaves out and where to find it. */
export default function ToDoBanner({onSelectFilter}: Props) {
  'use memo';

  return (
    <Banner
      align='center'
      border={false}
      cardClassName='py-x1!'
      className='mt-x1'
      data-testid='to-do-banner'
    >
      <Text size='s' color='tertiary' className='w-full'>
        <Text bold className='block'>
          “To Do” shows your assignments due within the next {TO_DO_PROXIMITY} days.
        </Text>
        Looking for another assignment? Check{' '}
        <Anchor
          as='button'
          type='button'
          inheritColor
          underlined
          onClick={() => onSelectFilter('open')}
        >
          Open
        </Anchor>{' '}
        or{' '}
        <Anchor
          as='button'
          type='button'
          inheritColor
          underlined
          onClick={() => onSelectFilter('closed')}
        >
          Closed
        </Anchor>
        .
      </Text>
    </Banner>
  );
}
